import { PublicClientApplication } from '@azure/msal-browser';
import { getUipConfig } from '../config/actions';
/** Singleton */
var msal;
export var getMsalClient = function () {
    if (typeof window === 'undefined') {
        return msal || (msal = new PublicClientApplication(getUipConfig()));
    }
    var existingClient = window.MsalClient;
    if (!existingClient) {
        window.MsalClient = msal || (msal = new PublicClientApplication(getUipConfig()));
    }
    return window.MsalClient;
};
